import { createI18n } from 'vue-i18n';

import en from '../locales/en.json';
import nl from '../locales/nl.json';

export default createI18n({
  locale: import.meta.env.VUE_APP_I18N_LOCALE || 'en',
  messages: { en, nl },
  legacy: false,
})
